"use client";

import { Button, Subtitle2, Text, Title3 } from "@fluentui/react-components";
import { useTranslations } from "next-intl";
import Link from "next/link";

export default function Forbidden() {
  const t = useTranslations();
  return (
    <div className="flex items-center justify-center w-full min-h-screen">
      <section className="bg-neutral-background-1">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div className="flex flex-col items-center justify-center mx-auto max-w-screen-sm text-center">
            <Text className="mb-4 text-primary-500" size={1000} weight="bold">
              403
            </Text>
            <Title3 className="mb-4 text-gray-900">{t("error.page.forbidden.title")}</Title3>
            <Subtitle2 className="mb-4 text-gray-500">{t("error.page.forbidden.msg")}</Subtitle2>
            <Link href="/">
              <Button appearance="primary" size="large">
                {t("common.btn.back_to_home")}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
